module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/anchor-center-down-62dbeccafa1d8f6b5511c01ae264b491.svg";